import { lockBodyScroll, unlockBodyScroll } from './bodyScrollLock';

/**
 * 在 class 组件 componentDidUpdate 中同步弹框可见性与 body 滚动锁。
 */
export const syncModalBodyScrollLock = (visible: boolean, prevVisible: boolean) => {
    if (visible && !prevVisible) {
        lockBodyScroll();
        return;
    }

    if (!visible && prevVisible) {
        unlockBodyScroll();
    }
};

/** 组件卸载时若弹框仍打开，需主动释放滚动锁 */
export const releaseModalBodyScrollLock = (visible: boolean) => {
    if (visible) {
        unlockBodyScroll();
    }
};
